import '/modules/common/css/ui/summary-stats.css';
import {UIElement} from "./ui";
import * as $ from "jquery";

/**
 * A simple statistics shower
 * It's a UI element that takes an array of data and shows relevant summary statistics on that data
 * Has a legend that shows on mouseover (touch on mobile)
 *
 * This class is meant to be overridden to implement the actual stats and UI to show them
 * @abstract
 * @extends UIElement
 */
class AbstractSimpleStatsShower extends UIElement {

    /**
     *
     * @param data {Array<number|string>} The data to show stats for
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig) {
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.data = data.filter(a => a !== null && a !== undefined).sort((a, b) => a - b);
        this.onShowLegendCallbacks = [];
        this.onHideLegendCallbacks = [];
    }

    getClassName() {
        return "AbstractSimpleStatsShower";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div class="summary-stats"><div class="stats-elements"></div></div>');

            this._generateUIElements();

            if (this.isMobileDevice) {
                $('body').click((event) => {
                    if ($(event.target).parents('.summary-stats').length === 0) {
                        this.hideLegend();
                    }
                });
                this.uiElement.click(()=> {
                    this.showLegend();
                    this.logStat("SHOW_LEGEND");
                });
            } else {
                this.uiElement.on({
                    mouseenter: ()=> {
                        this.showLegend();
                        this.logStat("SHOW_LEGEND");
                    },
                    mouseleave: ()=> {
                        this.hideLegend();
                        this.logStat("HIDE_LEGEND");
                    }
                });
            }
        }
        return this.uiElement;
    }

    /**
     * This method is meant to be overridden and should add all the UI elements to show the stats to this.UIElement
     * @private
     */
    _generateUIElements(){}

    /**
     * This method is meant to be overridden and should add all the UI elements to show the stats legendd to legendElem
     * @param legendElem {jQuery}
     * @private
     */
    _generateLegendElements(legendElem) {}

    /**
     * Add a callback that executes on show legend
     * @param callback {function} A callback that takes this shower as a parameter
     */
    onShowLegend(callback) {
        this.onShowLegendCallbacks.push(callback);
    }

    /**
     * Add a callback that executes on hide legend
     * @param callback {function} A callback that takes this shower as a parameter
     */
    onHideLegend(callback) {
        this.onHideLegendCallbacks.push(callback);
    }

    /**
     * Show this shower's legend
     */
    showLegend() {
        const legendElem = $('<div class="summary-legend"></div>').hide();
        this.uiElement.append(legendElem);
        this._generateLegendElements(legendElem);
        legendElem.show();
        this.onShowLegendCallbacks.forEach(c => c(this));
    }

    /**
     * Hide this shower's legend
     */
    hideLegend() {
        $('div.summary-legend', this.uiElement).remove();
        this.onHideLegendCallbacks.forEach(c => c(this));
    }
}

export {AbstractSimpleStatsShower}